import { render, staticRenderFns } from "./SelectDescriptorSearchView.vue?vue&type=template&id=c5b9944a&scoped=true"
import script from "./SelectDescriptorSearchView.vue?vue&type=script&lang=js"
export * from "./SelectDescriptorSearchView.vue?vue&type=script&lang=js"
import style0 from "./SelectDescriptorSearchView.vue?vue&type=style&index=0&id=c5b9944a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b9944a",
  null
  
)

export default component.exports